<button
  sdButton
  type="accent"
  size="l"
  (click)="checkoutContactFormService.submit()"
  [disabled]="checkoutContactFormService.isSubmitting$ | async"
>
  Оформить заказ
</button>
